
const GYSP_ADMIN_TOKEN = 'GYSP_ADMIN_TOKEN'
const GYSP_ROLE_ID = 'GYSP_ROLE_ID'
const GYSP_ROLE_NAME = 'GYSP_ROLE_NAME'
const GYSP_CURRENT_MENU = 'GYSP_CURRENT_MENU'
const GYSP_ROLE_MENU = 'GYSP_ROLE_MENU'
const GYSP_USER = 'GYSP_USER'
const GYSP_ACTION_DATA = 'GYSP_ACTION_DATA'
const GKSP_LOGINTAG = 'GKSP_LOGINTAG'


import { aesEncrypt, aesDecrypt } from '@/scripts/aesHelper.js'

export function getStorageAdminUser() {
  let data = localStorage.getItem(GYSP_USER)
  return data ? JSON.parse(data) : {}
}
export function setStorageAdminUser(data) {
  return localStorage.setItem(GYSP_USER, JSON.stringify(data))
}

export function getStorageToken() {
  return localStorage.getItem(GYSP_ADMIN_TOKEN)
}
export function setStorageToken(token) {
  return localStorage.setItem(GYSP_ADMIN_TOKEN, token)
}
export function getActionData() {
  return localStorage.getItem(GYSP_ACTION_DATA)
}
export function setActionData(data) {
  return localStorage.setItem(GYSP_ACTION_DATA, JSON.stringify(data))
}
export function getStorageUserRoleName() {
  return localStorage.getItem(GYSP_ROLE_NAME)
}
export function setStorageUserRoleName(name) {
  // console.log(name)
  return localStorage.setItem(GYSP_ROLE_NAME, name)
}
export function setStorageUserRoleId(id) {
  return localStorage.setItem(GYSP_ROLE_ID, id)
}
export function getStorageUserRoleId() {
  return localStorage.getItem(GYSP_ROLE_ID)
}
export function setStorageCurrentMenu(data) {
  delete data.children
  return localStorage.setItem(GYSP_CURRENT_MENU, JSON.stringify(data))
}
export function getStorageCurrentMenu() {
  let data = localStorage.getItem(GYSP_CURRENT_MENU)
  return data ? JSON.parse(data) : {}
}

export function setStorageMenuByRole(id, list) {
  let oData = localStorage.getItem(GYSP_ROLE_MENU)
  oData = oData ? JSON.parse(oData) : {}
  oData[id] = list
  return localStorage.setItem(GYSP_ROLE_MENU, JSON.stringify(oData))
}
export function getStorageMenuByRole(id) {
  let oData = localStorage.getItem(GYSP_ROLE_MENU)
  // console.log(oData)
  oData = oData ? JSON.parse(oData) : {}
  if (oData[id]) {
    return oData[id]
  } else {
    return []
  }
}

//设置登录标识，用来控制登录有效期
export function setStorageUserIsLogin(id, milliseconds) {
  return setItemWithExpiration(GKSP_LOGINTAG, id, milliseconds);
}

//获取登录标识，用来控制登录有效期
export function getStorageUserIsLogin() {
  return getItemWithExpiration(GKSP_LOGINTAG);
}

export function setItem(key,data) {
 return localStorage.setItem(key, JSON.stringify(data))
}
export function getItem(key) {
  let data = localStorage.getItem(key)
  return data ? JSON.parse(data) : {}
}


//设置数据，带有效期
export function setItemWithExpiration(key, data, milliseconds) {

  const expirationTime = Date.now() + milliseconds;
  var data = {
    data: data,
    expiration: expirationTime
  };
  var str = JSON.stringify(data);
  str = aesEncrypt(str);
  return localStorage.setItem(key, str)
}

//获取数据
function getItemWithExpiration(key) {
  const item = localStorage.getItem(key);
  if (!item) {
    return null; // 如果没有数据则返回null
  }
  var itemValue = aesDecrypt(item);
  const parsedItem = JSON.parse(itemValue);
  if (parsedItem.expiration < Date.now()) {
    localStorage.removeItem(key); // 如果数据已过期，则删除它
    return null;
  }

  return parsedItem.data; 
}


export function loginOutStorage() {
  localStorage.setItem(GYSP_ADMIN_TOKEN, '')
  localStorage.setItem(GYSP_ROLE_ID, '')
  localStorage.setItem(GYSP_CURRENT_MENU, '')
  localStorage.setItem(GYSP_ROLE_MENU, '')
  localStorage.setItem(GYSP_ROLE_NAME, '')
  localStorage.setItem(GYSP_ACTION_DATA, '')
  localStorage.setItem(GYSP_USER, '')

  localStorage.setItem(GKSP_LOGINTAG, '')

  localStorage.setItem('chatId', '')
  localStorage.setItem('hxIsLogin', '')
  localStorage.setItem('historyChatId', JSON.stringify({ contact: '', group: '' }))
  sessionStorage.clear()
}